import Vue from 'vue';
import { ValidationObserver } from 'vee-validate';
Vue.component('ValidationObserver', ValidationObserver);